import { Container } from './styled';
import { List } from './List';


export function Aside() {

    return (
        <Container>
            <List />
        </Container>
    );
}   